import { render, staticRenderFns } from "./femsa.vue?vue&type=template&id=b2fa101a&scoped=true"
var script = {}
import style0 from "./femsa.vue?vue&type=style&index=0&id=b2fa101a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2fa101a",
  null
  
)

export default component.exports